export enum Status {
	suspended = 'suspended',
	available = 'available',
}

export default class MarketSupply {
	status: Status | null;

	informationPublicSince: Date | null;

	statusDateFrom: Date | null;

	statusDateTo: Date | null;

	constructor(
		status: Status | null,
		informationPublicSince: Date | null,
		statusDateFrom: Date | null,
		statusDateTo: Date | null
	) {
		this.status = status;
		this.informationPublicSince = informationPublicSince;
		this.statusDateFrom = statusDateFrom;
		this.statusDateTo = statusDateTo;
	}

	get isSuspended(): boolean {
		return this.status === Status.suspended;
	}

	get isAvailable(): boolean {
		return this.status === Status.available;
	}
}
